module.exports = __webpack_public_path__ + "img/garden-1.831eee20.jpeg";